import { Loader } from "@productlane/ui"

import { api } from "@/lib/api"

export function ApiSlowestEndpointsChart() {
	const query = api.apiAnalytics.adminSlowestEndpoints.useQuery({ days: 14 })

	return (
		<div className="rounded-lg border p-4">
			<h3 className="mb-3 text-sm font-medium text-gray-800 dark:text-white">
				Slowest endpoints by p95 (last 14 days)
			</h3>
			{query.isLoading || !query.data ? (
				<div className="flex h-32 items-center justify-center">
					<Loader />
				</div>
			) : query.data.length === 0 ? (
				<div className="text-xs text-secondary">No traffic.</div>
			) : (
				<div className="flex flex-col gap-1 font-mono text-xs">
					{query.data.map((row) => (
						<div
							key={`${row.method}-${row.path}`}
							className="flex items-center justify-between gap-2"
						>
							<span className="truncate">
								<span className="text-secondary">{row.method}</span> {row.path}
							</span>
							<span className="tabular-nums">
								{row.p95.toLocaleString()} ms
							</span>
						</div>
					))}
				</div>
			)}
		</div>
	)
}
